import Api from "./Api";

export const StallBookingService = {

    getStallBookingsByVenue: async (venueId) => {

        const res = await Api.get(`/stall-bookings?venueId=${venueId}`);

        return res.data;

    }

};